import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import addEditCopyClaims from '../components/addEditCopyClaims.vue';

var EditClaimsPage = function (_super) {
  __extends(EditClaimsPage, _super);

  function EditClaimsPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EditClaimsPage = __decorate([Component({
    components: {
      addEditCopyClaims: addEditCopyClaims
    }
  })], EditClaimsPage);
  return EditClaimsPage;
}(Vue);

export default EditClaimsPage;